// extracted by mini-css-extract-plugin
module.exports = {"root":"Hero_root__27so_","image":"Hero_image__255g6","title":"Hero_title__3shgl","subtitle":"Hero_subtitle__uflbW","copy":"Hero_copy__3JBlV"};